const BASE_URL = process.env.REACT_APP_API_URL;

function getToken() {
    return localStorage.getItem("d_c_c_t");
}
      


export async function getInstitutions(query:string, perPage:number, pageNo:number) {
    try {
      const response = await fetch(`${BASE_URL}/tenant?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getToken()}`,
        },
      });

      console.log(response);

      if (!response.ok) {
        throw new Error('Failed to get institutions');
      }

      const result = await response.json();
      console.log('Institutions fetched successfully:', result);
      return result;
    } catch (error) {
      console.error('Error fetching institutions:', error);
      throw new Error('Error fetching institutions');
    }

}

export async function registerUsersBulk(users: any[]) {
  try {
    const response = await fetch(`${BASE_URL}/auth/register-bulk`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${getToken()}`,
      },
      body: JSON.stringify({ users }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Failed to register users');
    }

    return result;
  } catch (error: any) {
    console.error('Error registering users:', error);
    throw new Error(error.message || 'An unexpected error occurred while registering users');
  }
}




export async function updateApproveStatus(id: string, approved: boolean) {
  try {
    const response = await fetch(`${BASE_URL}/tenant/${id}/approve`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`, // Ensure getToken provides a valid token
      },
      body: JSON.stringify({ id, approved }), // Ensure payload matches backend expectations
    });

    if (!response.ok) {
      const errorMessage = `Failed to update approval status. Server responded with status: ${response.status}`;
      console.error(errorMessage);
      throw new Error(errorMessage);
    }

    const result = await response.json();
    console.log("Approval status updated successfully:", result);
    return result;
  } catch (error: any) {
    console.error("Error updating approval status:", error.message || error);
    throw error; // Propagate the error to handle it in the calling function
  }
}


